/**
 * @generated SignedSource<<7b9b2b5e8b99e05cc5ed4d2f22d07d90>>
 * @relayHash 3279cb796ca15f5627d629f70f5f37ab
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f8d8b9eec1994f8c7411bb76dc10be0eab8514a591963f4d58e52f323d48b997

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { VirtualAgentSidebarQuery } from './VirtualAgentSidebarQuery.graphql';

import checkForAiEnabledFF_provider from '@atlassian/jira-relay-provider/src/jsm-va-is-require-ai-enabled.relayprovider';

const node: PreloadableConcreteRequest<VirtualAgentSidebarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "f8d8b9eec1994f8c7411bb76dc10be0eab8514a591963f4d58e52f323d48b997",
    "metadata": {},
    "name": "VirtualAgentSidebarQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": checkForAiEnabledFF_provider
    }
  }
};

export default node;
